import findAndReplacePlaceholders from './findAndReplacePlaceholders'

export default findAndReplacePlaceholders
